import { MessageSquarePlus } from 'lucide-react'

export function EmptyState({ onNewTicket }: { onNewTicket?: () => void }) {
  return (
    <div className="flex flex-col items-center justify-center py-16 text-center">
      <div className="w-16 h-16 rounded-full bg-brand-50 flex items-center justify-center mb-4">
        <MessageSquarePlus className="w-8 h-8 text-brand-500" />
      </div>
      <h3 className="text-lg font-semibold text-gray-900 mb-1">No feedback yet</h3>
      <p className="text-gray-500 mb-6 max-w-sm">
        Submit your first feedback to get started. We'll review it and keep you updated on progress.
      </p>
      {onNewTicket && (
        <button
          onClick={onNewTicket}
          className="px-4 py-2 bg-brand-500 text-white rounded-lg font-medium hover:bg-brand-600 transition-colors"
        >
          Submit Feedback
        </button>
      )}
    </div>
  )
}
